// @flow

import * as React from "react";
import cx from "classnames";

import Transition from "react-transition-group/Transition";

import styles from "./FlashMessages.scss";

type FlashMessageType = "success" | "failure";

type FlashMessageProps = {
  children: React.Node,
  onExited: () => void,
  timeouts: {|
    enter: number,
    exit: number,
    visibility: number
  |},
  type: FlashMessageType
};

type FlashMessageState = {
  isKeptVisible: boolean
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
};

class FlashMessage extends React.Component<FlashMessageProps, FlashMessageState> {
  state = {
    isKeptVisible: true
  };

  componentDidMount() {
    const { timeouts } = this.props;
    setTimeout(() => this.setState({ isKeptVisible: false }), timeouts.visibility);
  }

  render() {
    const { children, onExited, timeouts, type } = this.props;
    const { isKeptVisible } = this.state;
    return (
      <Transition
        appear
        in={isKeptVisible}
        onExited={() => setTimeout(onExited, timeouts.exit)}
        timeout={{ enter: timeouts.enter, exit: timeouts.exit }}
      >
        {state => (
          <div
            className={cx(styles.message, {
              [styles.failure]: type === "failure",
              [styles.success]: type === "success"
            })}
            style={{ ...transitionStyles[state] }}
          >
            {children}
          </div>
        )}
      </Transition>
    );
  }
}

export default FlashMessage;
